export { default as THead } from "./t-head";
